import { ChangePasswordPageState } from '../../../../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';
import { getApiValidationCall } from './getApiValidationCall';
import { validateFormat } from './validateFormat';
import { validateRules } from './validateRules';
import { validateSequence } from './validateSequence';
import { validateSequenceFromAsciiValues } from './validateSequenceFromAsciiValues';

export function getOnChangePassword(lang: string, setApiError: (msg: string) => void, setRules: (rules: ChangePasswordPageState) => void) {
  return (val: string) => {
    const newRules = validateRules(val);
    if (val !== '' && validateFormat(newRules, val) && validateSequence(val) && validateSequenceFromAsciiValues(val)) {
      getApiValidationCall(
        lang,
        () => {
          setApiError(null);
        },
        (error: string) => {
          setApiError(error);
        },
      )(val);
    }
    setRules(newRules);
  };
}
